import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import BlogComponent from '../components/blog/BlogPageComponent'
import { Helmet } from "react-helmet";

const BlogPage = () => {
  return ( 
    <div>
      
<Helmet>
        <title>Pet Care Tips & Grooming Advice | FluffyTouch Blog</title>
        <meta
          name="description"
          content="Get expert pet care tips! Read our blog for grooming guides, breed-specific advice & home care solutions. Subscribe for monthly pet hacks!"
        />
      </Helmet>
   
   
        <Navbar/>
        <BlogComponent/>
        <Footer/>
    </div>
  )
}

export default BlogPage;